import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { themeSlice, userSlice } from './slices';

export const useLocalStore = create(
    persist(
        (set, get) => ({
            ...themeSlice(set),
            ...userSlice(set),
        }),
        {
            name: 'localStore',
            storage: createJSONStorage(() => localStorage), // or "sessionStorage"

        }
    )
);